import { render, staticRenderFns } from "./CreateEditRegion.vue?vue&type=template&id=b6ee3f12"
import script from "./CreateEditRegion.vue?vue&type=script&lang=js"
export * from "./CreateEditRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports